<template>
  <a-spin :spinning="isLoading">
    <div class="statistics-header">
      <a-button
        type="primary"
        size="small"
        @click="isFilterDrawerVisible = true"
      >
        {{ $tm('statistic.filter.selectDepartment') }}
      </a-button>
      <div class="cycle-container">
        <Cycle />
      </div>
    </div>
    <DepartmentTagList
      :selected-departments="selectedDepartments"
      :limit="5"
      @delete="onUnselectDepartment"
      @view-more="isFilterDrawerVisible = true"
    />
    <a-row
      :gutter="[16, 16]"
      :style="{ marginTop: '16px' }"
    >
      <a-col
        :lg="24"
        :xxl="12"
      >
        <Summary :department-ids="departmentIds" />
      </a-col>
      <a-col
        :lg="24"
        :xxl="12"
      >
        <StatesChart :department-ids="departmentIds" />
      </a-col>
    </a-row>
    <UserStatusTable
      :department-ids="departmentIds"
      :style="{ marginTop: '16px' }"
    />
    <FilterDrawer
      ref="filterDrawerRef"
      v-model:is-loading="isLoading"
      v-model:is-visible="isFilterDrawerVisible"
      v-model:department-map="departmentMap"
      @filter="onFilter"
    />
  </a-spin>
</template>

<script>
import { defineComponent, ref, computed } from 'vue'

import Cycle from '@/components/Cycle'
import DepartmentTagList from '@/components/DepartmentTagList'
import FilterDrawer from './FilterDrawer'
import Summary from './Summary'
import StatesChart from './StatesChart'
import UserStatusTable from './UserStatusTable'

export default defineComponent({
  name: 'Statistics',
  components: {
    Cycle,
    DepartmentTagList,
    FilterDrawer,
    Summary,
    StatesChart,
    UserStatusTable
  },
  props: {},
  setup () {
    const filterDrawerRef = ref()
    const isLoading = ref(false)
    const isFilterDrawerVisible = ref(false)
    const departmentIds = ref([])
    const departmentMap = ref({})
    const selectedDepartments = computed(() =>
      departmentIds.value.map(id => ({
        id,
        name: departmentMap.value[id]
      }))
    )

    function onFilter (checkedDepartmentIds) {
      departmentIds.value = checkedDepartmentIds
    }

    function onUnselectDepartment (unselecteId) {
      filterDrawerRef.value.uncheckKey(unselecteId)
      departmentIds.value = departmentIds.value.filter(id => id !== unselecteId)
    }

    return {
      filterDrawerRef,
      isLoading,
      isFilterDrawerVisible,
      departmentIds,
      onFilter,
      selectedDepartments,
      departmentMap,
      onUnselectDepartment
    }
  }
})
</script>

<style lang="less" scoped>
:deep(.bg-btn) {
  border: none;
  background-color: #F7F8F9;
}
</style>
